import { AfterResponseHook, BeforeRequestHook } from "ky"
import { getToken, logout } from "providers/A12n"

import { parseApiError } from "./utils"

export const afterHooks: Record<string, AfterResponseHook> = {
  handleEmptyResponse: (_input, _options, response) => {
    if (response.status === 204 || response.status === 202) {
      const o = JSON.stringify({})
      return new Response(o, { status: 200 })
    } else {
      return response
    }
  },
  handleUnauthorised: async (_input, _options, response) => {
    if (response.status === 401) {
      await logout()
      return
    }
    if (response.status === 403) {
      await logout()
      return
    }
    return response
  },
  handleErrors: async (_input, _options, response) => {
    if (!response.ok) {
      const e = await parseApiError(response)
      throw e
    } else {
      return response.clone()
    }
  },
}

export const beforeHooks: Record<string, BeforeRequestHook> = {
  setAuthHeader: async (request) => {
    const accessToken = await getToken()
    if (accessToken) {
      request.headers.set("Authorization", "Bearer " + accessToken)
    }
  },
  setAgencyHeader: async (request) => {
    const agencyId = localStorage.getItem("agencyId") || undefined
    if (agencyId) {
      request.headers.append("agencyId", agencyId)
    }
  },
}
